import { useTranslator } from 'tradera/lang/translate';
import { itemStates } from './item-states';
import { Badge as BadgeComponent } from 'tradera/components/badge/badge';
import type { ItemState } from 'tradera/state/services/types/webapi-member-generated';

type BadgeProps = {
    itemState: ItemState;
};

export const Badge = ({ itemState }: BadgeProps) => {
    const { t } = useTranslator();

    switch (itemState) {
        case itemStates.bidderAuctionRemoved:
            return (
                <BadgeComponent theme="dark" compact>
                    {t('myt_itemState_active_bidderAuctionRemoved')}
                </BadgeComponent>
            );
        case itemStates.bidderBidRemoved:
            return (
                <BadgeComponent theme="dark" compact>
                    {t('myt_itemState_active_bidderBidRemoved')}
                </BadgeComponent>
            );
        case itemStates.bidderEndedWon:
            return (
                <BadgeComponent theme="success" compact>
                    {t('myt_itemState_active_bidderEndedWon')}
                </BadgeComponent>
            );
        case itemStates.bidderEndedReservedPriceNotReached:
            return (
                <BadgeComponent theme="dark" compact>
                    {t(
                        'myt_itemState_active_bidderEndedReservedPriceNotReached',
                    )}
                </BadgeComponent>
            );
        case itemStates.bidderEndedNotWon:
            return (
                <BadgeComponent theme="dark" compact>
                    {t('myt_itemState_active_bidderEndedNotWon')}
                </BadgeComponent>
            );
        case itemStates.bidderActiveLeading:
            return (
                <BadgeComponent theme="success" compact>
                    {t('myt_itemState_active_bidderActiveLeading')}
                </BadgeComponent>
            );
        case itemStates.bidderActiveReservedPriceNotReached:
            return (
                <BadgeComponent theme="branded" compact>
                    {t(
                        'myt_itemState_active_bidderActiveReservedPriceNotReached',
                    )}
                </BadgeComponent>
            );
        case itemStates.bidderActiveOverbidden:
            return (
                <BadgeComponent theme="branded" compact>
                    {t('myt_itemState_active_bidderActiveOverbidden')}
                </BadgeComponent>
            );
        case itemStates.generalActive:
        case itemStates.buyItNowActive:
        case itemStates.shopItemActive:
            return null;
        case itemStates.generalEnded:
            return (
                <BadgeComponent compact theme="dark">
                    {t('myt_itemState_active_generalEnded')}
                </BadgeComponent>
            );
        case itemStates.shopItemEnded:
            return (
                <BadgeComponent compact theme="dark">
                    {t('myt_itemState_active_shopItemEnded')}
                </BadgeComponent>
            );
        case itemStates.buyItNowEndedWon:
            return (
                <BadgeComponent compact theme="success">
                    {t('myt_itemState_active_buyItNowEndedWon')}
                </BadgeComponent>
            );
        case itemStates.buyItNowEnded:
            return (
                <BadgeComponent compact theme="dark">
                    {t('myt_itemState_active_buyItNowEnded')}
                </BadgeComponent>
            );
        case itemStates.shopItemEndedWon:
            return (
                <BadgeComponent compact theme="success">
                    {t('myt_itemState_active_shopItemEndedWon')}
                </BadgeComponent>
            );
        default:
            throw new Error('Unknown item state');
    }
};
